<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="container row">
      <AccountList
        @select-account="enterEditMode"
        @remove-account="removeAccount"
        ref="ListRef"
      />
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createAccount">
              <h2>Dados do cliente</h2>
              <div class="form-group">
                <span class="label label-primary pull-right"
                  >Saldo: {{ totalToCurrencyBR(form.actualBalance) }}
                </span>
              </div>
              <div class="space-25"></div>
              <div class="form-group">
                <label>Nome</label>
                <input type="text" class="form-control" v-model="form.name" />
              </div>

              <div class="form-group">
                <label>Descrição</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.description"
                />
              </div>
              <div class="form-group">
                <label>Valor de abertura</label>
                <input
                  type="number"
                  class="form-control"
                  step="0.01"
                  value="0.00"
                  placeholder="0.00"
                  v-model="form.openedAmount"
                />
              </div>
              <div class="form-group">
                <label>Data de abertura</label>
                <p>{{ DateBR(form.createdAt) }}</p>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="form.defaultAccount"
                />
                <label class="form-check-label checkboxlabel"
                  >Conta padrão</label
                >
              </div>

              <br />
              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                v-if="!form.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Conta
              </button>

              <div v-if="form.control.editModeId">
                <button
                  type="button"
                  class="btn btn-outline"
                  href="mail_compose.html"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  @click="updateAccount"
                >
                  <i class="fa fa-save"></i>
                  Salvar Conta
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AccountList from './components/account-list/AccountList';
import { toast } from '@/plugins/toast';
export default {
  components: {
    AccountList,
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        actualBalance: '',
        openedAmount: '',
        createdAt: '',
        defaultAccount: false,
        control: {
          editModeId: '',
        },
      },
    };
  },
  methods: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    DateBR(dt) {
      return dt ? new Date(dt).toLocaleString('pt-br') : '';
    },
    enterEditMode(account) {
      this.form.name = account.name;
      this.form.description = account.description;
      this.form.actualBalance = account.actualBalance;
      this.form.openedAmount = account.openedAmount;
      this.form.createdAt = account.createdAt;
      this.form.defaultAccount = account.defaultAccount;
      this.form.control.editModeId = account._id;
    },
    disableEditMode() {
      this.form.name = '';
      this.form.description = '';
      this.form.actualBalance = '';
      this.form.openedAmount = '';
      this.form.createdAt = '';
      this.form.defaultAccount = false;
      this.form.control.editModeId = '';
    },
    async createAccount() {
      try {
        await this.$store.dispatch('FINANCIAL-ACCOUNT/Create', {
          name: this.form.name,
          description: this.form.description,
          openedAmount: this.form.openedAmount * 100,
          defaultAccount: this.form.defaultAccount,
        });
        this.disableEditMode();
        await this.$refs.ListRef.listAccounts();
        toast.success('Conta criada com sucesso!');
      } catch (error) {
        toast.error('Não foi possível criar a conta.');
      }
    },
    async updateAccount() {
      try {
        const payload = {
          name: this.form.name,
          description: this.form.description,
          openedAmount: this.form.openedAmount * 100,
          defaultAccount: this.form.defaultAccount,
        };

        await this.$store.dispatch('FINANCIAL-ACCOUNT/Update', {
          payload,
          financialAccountId: this.form.control.editModeId,
        });
        this.disableEditMode();
        await this.$refs.ListRef.listAccounts();
        toast.success('Conta salva com sucesso!');
      } catch (error) {
        toast.error('Não foi possível criar a conta.');
      }
    },
    async removeAccount(id) {
      try {
        confirm(
          `Ao apagar essa conta todos seu movimentos serão apagados, confirma exclui-lá?`,
        );
        await this.$store.dispatch('FINANCIAL-ACCOUNT/Delete', {
          financialAccountId: id,
        });
        toast.success('Conta removida com sucesso!');
        await this.$refs.ListRef.listAccounts();
      } catch (error) {
        toast.error('Não foi possível criar a conta.');
      }
    },
  },
};
</script>
